import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import CircularProgress from '@material-ui/core/CircularProgress'

import { getZoomEvents, getSingleCourseDetails } from '../../services/saga'

import {
  updateZoomCourseId,
  loadZoomEventsData,
  updateZoomCourseDetails
} from '../../actions'

import { StepOne, StepTwo, StepThree } from './Index'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import FullScreenDialog from './FullScreenDialog'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import LinearProgress from '@material-ui/core/LinearProgress'

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  },
  addCourses: {
    display: 'flex',
    justifyContent: 'flex-end',
    float: 'right'
  }
}))

const steps = ['Select Course', 'Review Selection', 'Download']

function getStepContent(step) {
  switch (step) {
    case 0:
      return <StepOne />
    case 1:
      return <StepTwo />
    case 2:
      return <StepThree />
    default:
      throw new Error('Unknown step')
  }
}

const ZoomCoursesHome = (props) => {
  const classes = useStyles()
  const { updateCourseId, updateZoomEvents, updateCourseDetails } = props

  const [activeStep, setActiveStep] = React.useState(0)

  const [open, setOpen] = React.useState(false)
  const [dialogTitle, setDialogTitle] = React.useState('')
  const [dialogText, setDialogText] = React.useState('')

  const [fullPageModel, setFullPageModel] = React.useState(false)
  const [courseId, setCourseId] = React.useState('')

  const [helperText, setHelperText] = React.useState(
    'Type course ID and press enter to continue'
  )
  const [errorCourseId, setErrorCourseId] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleChange = (e) => {
    setCourseId(e.target.value)
    updateCourseId(e.target.value)
  }

  const keyPress = async (e) => {
    if (e.keyCode == 13) {
      try {
        setLoading(true)
        updateCourseId(courseId)

        const response = await getSingleCourseDetails(courseId)

        setLoading(false)

        if (response.status !== 200) {
          setHelperText('Unable to find calendar events for requested course.')
          setErrorCourseId(true)
        }

        if (response.status === 200) {
          setErrorCourseId(false)
          setHelperText('Type course ID and press enter to continue')

          let dataSet = {
            data: response.data,
            method: 'ADD'
          }

          updateCourseDetails(response.data)

          // updateZoomEvents(dataSet);

          setFullPageModel(true)
        }
      } catch (error) {
        console.log('error', error)
        setHelperText('Unable to find calendar events for requested course.')
        setErrorCourseId(true)
        setLoading(false)
      }
    }
  }

  useEffect(() => {}, [courseId])

  return (
    <React.Fragment>
      <Typography component='h1' variant='h5' align='center'>
        Zoom Creation
      </Typography>

      <Divider />

      <div>
        {/* <br />
                <Box component="div" >
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        style={{float:'right'}}
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() => { setFullPageModel(true) }}
                    >
                        Add Zoom Courses
                    </Button>
                </Box> */}
        <br /> <br /> <br />
        <Grid container justify='center' alignItems='center' spacing={3}>
          <Grid item xs={7}>
            {/* <Typography>Type course ID to proceed</Typography> */}

            <FormControl fullWidth>
              <TextField
                type='number'
                error={errorCourseId}
                id='outlined-name'
                label='Course ID'
                variant='outlined'
                onKeyDown={keyPress}
                onChange={handleChange}
                helperText={helperText}
              />
              {loading ? <LinearProgress /> : null}
            </FormControl>
          </Grid>
        </Grid>
      </div>

      <FullScreenDialog
        courseId={courseId}
        fullPageModel={fullPageModel}
        setFullPageModel={setFullPageModel}
      />
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.ZoomMeetings
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateCourseId: (courseId) => {
    dispatch(updateZoomCourseId(courseId))
  },

  updateZoomEvents: (data) => {
    dispatch(loadZoomEventsData(data))
  },

  updateCourseDetails: (data) => {
    dispatch(updateZoomCourseDetails(data))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ZoomCoursesHome)
